import styled from '@emotion/styled';
import {Chip, Dropdown} from '@bosch/react-frok';

export const DropdownInput = styled(Dropdown)`
    max-width: 65%;
    min-width: 385px;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const LocaleSelection = styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;
